import {
  Routes, Route, Navigate, useLocation
} from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../../utils/authContext';
import AdminLayout from '../Admin/AdminLayout';
import Dashboard from '../Admin/Dashboard';
import TenantManagement from '../Admin/TenantManagement';
import PlanManagement from '../Admin/PlanManagement';
import FeatureManagement from '../Admin/FeatureManagement';
import FeatureDefinitionsManagement from '../Admin/FeatureDefinitionsManagement';
import Login from '../Admin/Login';

function AdminApp() {
  const { isLoggedIn, checkTokenValidity } = useAuth();
  const location = useLocation();

  useEffect(() => {
    console.log('AdminApp: Composant chargé, chemin actuel:', location.pathname);
    console.log("AdminApp: État d'authentification:", { isLoggedIn });

    // Vérifier le token stocké et sa validité
    const token = localStorage.getItem('token');
    console.log('AdminApp: Token dans localStorage:', token ? 'Présent' : 'Absent');

    // Vérifier la validité du token si présent
    if (token && !isLoggedIn) {
      console.log('AdminApp: Token présent mais état déconnecté, vérification...');
      const isValid = checkTokenValidity();
      console.log('AdminApp: Résultat de la vérification du token:', isValid);
    }

    // Ajouter une classe au body pour le debugging visuel
    document.body.classList.add('admin-app-loaded');
  }, [isLoggedIn, location, checkTokenValidity]);

  // Si l'utilisateur n'est pas authentifié et n'est pas déjà sur la page de connexion,
  // le rediriger vers la page de connexion
  if (!isLoggedIn) {
    // Éviter la redirection en boucle si on est déjà sur /admin/login
    if (location.pathname === '/admin/login') {
      console.log('AdminApp: Déjà sur la page de connexion, affichage du composant Login');
      return <Login />;
    }

    console.log('AdminApp: Utilisateur non connecté, rendu des routes de connexion');
    return (
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    );
  }

  // Débuggons les éléments rendus
  console.log("AdminApp: Utilisateur connecté, rendu des routes d'administration");

  return (
    <div className="admin-app-wrapper">
      <Routes>
        <Route element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route
            path="dashboard"
            element={(
              <>
                {console.log('AdminApp: Rendu du composant Dashboard')}
                <Dashboard />
              </>
            )}
          />
          <Route path="tenants" element={<TenantManagement />} />
          <Route path="plans" element={<PlanManagement />} />
          <Route path="features" element={<FeatureDefinitionsManagement />} />
          <Route path="tenants/:tenantId/features" element={<FeatureManagement />} />
        </Route>
        {/* Route fallback pour tout autre chemin admin */}
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </div>
  );
}

export default AdminApp;
